import { useEffect, useRef, useState } from 'react';

const usePublicIp = () => {
    const [ip, setIp] = useState('');
    const [isIpResolved, setIsIpResolved] = useState(false);
    const resolvingPromiseRef = useRef(null);

    const resolvePublicIp = async () => {
        if (resolvingPromiseRef.current) {
            return resolvingPromiseRef.current;
        }

        resolvingPromiseRef.current = window.fetch(process.env.REACT_APP_IPIFY_API)
            .then((response) => response.json())
            .then((result) => {
                const resolvedIp = result?.ip || '';
                setIp(resolvedIp);
                return resolvedIp;
            })
            .catch(() => {
                setIp('');
                return '';
            })
            .finally(() => {
                setIsIpResolved(true);
                resolvingPromiseRef.current = null;
            });

        return resolvingPromiseRef.current;
    };

    useEffect(() => {
        let mounted = true;

        const syncPublicIp = async () => {
            try {
                const resolvedIp = await resolvePublicIp();
                if (!mounted) {
                    return;
                }
                setIp(resolvedIp);
            } finally {
                if (mounted) {
                    setIsIpResolved(true);
                }
            }
        };

        syncPublicIp();

        return () => {
            mounted = false;
        };
    }, []);

    return {
        ip,
        isIpResolved,
        resolvePublicIp,
    };
};

export default usePublicIp;
